import { convertUtcToVenueTime, getFormattedTime, quartileToDate } from '../dayjs';

export const formatDisplayTimeRange = (
  startQuartile: number,
  endQuartile: number,
  locale: string,
  venueTimezone: string,
) => {
  const rangeStart = quartileToDate(startQuartile);
  const rangeEnd = quartileToDate(endQuartile);
  const formattedStartTime = getFormattedTime(
    convertUtcToVenueTime(rangeStart.toISOString(), venueTimezone),
    locale,
  );
  const formattedEndTime = getFormattedTime(
    convertUtcToVenueTime(rangeEnd.toISOString(), venueTimezone),
    locale,
  );
  const formattedRangeDisplayTime =
    formattedStartTime !== formattedEndTime
      ? `${formattedStartTime} - ${formattedEndTime}`
      : formattedStartTime;

  return formattedRangeDisplayTime;
};
